<template>
	<v-layout v-if="!dataSame">
		<v-flex xs6>
			<old-version-marker/>
			<ContestOfferSummaryBidderDetails title="Oferent" :bidder-data="oldMain"/>
			<div v-for="(data, index) in oldOthers" :key="'old-data-' + index">
				<ContestOfferSummaryBidderDetails :title="'Współoferent nr: ' + (index + 1).toString()" :bidder-data="data"/>
			</div>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<ContestOfferSummaryBidderDetails title="Oferent" :bidder-data="currentMain"/>
			<div v-for="(data, index) in currentOthers" :key="'current-data-' + index">
				<ContestOfferSummaryBidderDetails :title="'Współoferent nr: ' + (index + 1).toString()" :bidder-data="data"/>
			</div>
		</v-flex>
	</v-layout>
</template>

<script>
  import OldVersionMarker from "@/view/logged/offer/compareComponents/oldVersionMarker";
  import NewVersionMarker from "@/view/logged/offer/compareComponents/NewVersionMarker";
  import ContestOfferSummaryBidderDetails from "@/view/logged/offer/components/ContestOfferSummaryBidderDetails";

  export default {
    name: "CompareSummaryBidderDetails",
    components: {ContestOfferSummaryBidderDetails, NewVersionMarker, OldVersionMarker},

    computed: {
      dataSame () {
        let comparisonResult = JSON.stringify(this.currentMain) === JSON.stringify(this.oldMain)
            && JSON.stringify(this.currentOthers) === JSON.stringify(this.oldOthers);
        if (comparisonResult === false) {
          this.$emit('dataDiffer', true);
        }
        return comparisonResult;
      }
    },

    props: {
      currentMain: { required: true, type: Object },
      oldMain: { required: true, type: Object },
      currentOthers: { required: true, type: Array },
      oldOthers: { required: true, type: Array },
    },
  };
</script>

<style scoped>

</style>